module.exports = __webpack_public_path__ + "static/img/015日文1稿.fe99aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/015日文1稿.jpg
// module id = vCj5
// module chunks = 0